import React from 'react';
import {
  bool, func, node, number, oneOfType, string,
} from 'prop-types';
import { ConfigProvider } from 'antd';
import ButtonWrapper from './nested/ButtonWrapper';
import ButtonContent from './nested/ButtonContent';

const ToggleButton = ({
  dispatcherTimerContent = null,
  showDrawer,
  showExpandIcon = true,
  loadMenuData,
  iconBackgroundColor,
  toggleKey,
  label,
  value,
  isVisible = true,
  icon,
  id,
}) => (
  <ConfigProvider
    theme={{
      components: {
        Avatar: {
          borderRadius: 8,
          fontSizeIcon: 20,
        },
      },
    }}
  >
    <ButtonWrapper
      isVisible={isVisible}
      loadMenuData={loadMenuData}
      showDrawer={showDrawer}
      toggleKey={toggleKey}
    >
      <ButtonContent
        id={id}
        dispatcherTimerContent={dispatcherTimerContent}
        showExpandIcon={showExpandIcon}
        iconBackgroundColor={iconBackgroundColor}
        label={label}
        value={value}
        icon={icon}
      />
    </ButtonWrapper>
  </ConfigProvider>
);

ToggleButton.propTypes = {
  showDrawer: func.isRequired,
  loadMenuData: func.isRequired,
  iconBackgroundColor: string.isRequired,
  toggleKey: number.isRequired,
  label: string.isRequired,
  value: oneOfType([string, number]).isRequired,
  isVisible: bool,
  showExpandIcon: bool,
  icon: node.isRequired,
  id: string.isRequired,
  dispatcherTimerContent: node,
};

export default ToggleButton;
